export default "/images/vendor/flag-icon-css/flags/1x1/gd.svg?1b313417e54a6f4446ee51fb4cfaf958";